import { connectFela } from '../../dependencies';
import EditCompanyButton from './EditCompanyButton';
import * as styles from './EditCompanyButton.styles';

export default connectFela(styles)(EditCompanyButton);
